<script setup lang="ts">
import { type ButtonColorVariant } from '../base/mr-button';
import type { IconProp } from '#imports';

interface IProps {
    proceedButtonName?: string;
    proceedButtonDisabled?: boolean;
    proceedButtonRightIcon?: IconProp;
    hasCancel?: boolean;
    cancelButtonName?: string;
    fillDesktop?: boolean;
    fixed?: boolean;
    mobileOnly?: boolean;
    desktopButtonMaxWidth?: string;
    inner?: boolean;
    proceedButtonLoading?: boolean;
    proceedButtonColor?: ButtonColorVariant;
}
const {
    proceedButtonName = 'ادامه',
    proceedButtonDisabled,
    proceedButtonRightIcon,
    hasCancel,
    cancelButtonName = 'بازگشت',
    fillDesktop,
    fixed,
    mobileOnly,
    desktopButtonMaxWidth = '220px',
    inner,
    proceedButtonLoading,
} = defineProps<IProps>();

const emit = defineEmits<{
    'click:proceed': [];
    'click:cancel': [];
}>();
</script>
<template>
    <div
        class="footer-container-root"
        :class="{ fixed, 'just-in-mobile': mobileOnly, inner }"
        :style="{ '--desktop-button-max-width': desktopButtonMaxWidth }"
    >
        <slot name="prepend" />
        <div class="actions" :class="{ fill: fillDesktop, cancel: hasCancel }">
            <mr-button
                v-if="hasCancel"
                full-width
                variant="bordered"
                class="action"
                @click="emit('click:cancel')"
            >
                {{ cancelButtonName }}
            </mr-button>
            <mr-button
                class="action"
                full-width
                :color="proceedButtonColor"
                :disabled="proceedButtonDisabled"
                :loading="proceedButtonLoading"
                :right-icon="proceedButtonRightIcon"
                @click="emit('click:proceed')"
            >
                {{ proceedButtonName }}
            </mr-button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.footer-container-root {
    display: flex;
    flex-direction: column;
    @include f-gap(8px, column);
    padding: 8px;
    width: 100%;
    background-color: transparent;
    justify-content: space-between;
    &.inner {
        padding: 0;
    }
    &.just-in-mobile {
        display: none;
    }
    @include mobile-only {
        &.just-in-mobile {
            display: flex;
        }
        &.fixed {
            background-color: white;
        }
        &:not(.fixed) {
            padding-inline: 0;
        }
    }
    .actions {
        display: flex;
        @include f-gap(8px);
        justify-content: space-between;
        &:not(.fill) {
            @include desktop-only {
                &:not(.cancel)::before {
                    content: ' ';
                }
                .action {
                    max-width: var(--desktop-button-max-width);
                }
            }
        }
    }
}
</style>
